import React, { Fragment, useCallback, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { Box, Heading, Text, Button } from 'grommet';
import BackwardCounter from 'components/common/BackwardCounter';
import * as ROUTES from 'components/common/Routes';
import { AuthorizedUserContext } from 'components/common/AuthorizedUser';
import AppCard from './AppCard';

const ZaaasPromo = () => (
  <Fragment>
    <Text color="accent-2" size="large" weight="bold">
      zaaas.io{' '}
    </Text>
    <Text weight="bold">
      is a platform for the self employed, the small business owner with 20 or
      fewer employees, the freelancer, the independent contractor. you are our
      customer. let us work for you by providing all your business applications
      for $10/month. seriously.
    </Text>
  </Fragment>
);

const LandingPage = props => {
  const authorizedUser = useContext(AuthorizedUserContext);
  const handleClick = useCallback(() => props.history.push(ROUTES.GET_NEXT));

  return (
    <Box
      background="transparent"
      direction="column"
      margin={{ left: 'medium', right: 'medium' }}
    >
      <Box background="transparent" basis="full" direction="row-responsive">
        <Box
          align="center"
          background="transparent"
          basis="67.67%"
          height="none"
          margin={{ bottom: 'medium', right: 'xsmall', top: 'medium' }}
          pad="medium"
        >
          <Text alignSelf="start" color="brand" size="large">
            {authorizedUser ? null : <ZaaasPromo />}
          </Text>
        </Box>
        <Box
          align="center"
          background="accent-3"
          basis="33.34%"
          height="none"
          margin={{ bottom: 'large', left: 'xsmall', top: 'large' }}
          round="large"
        >
          {authorizedUser ? null : <BackwardCounter />}
        </Box>
      </Box>
      <Box background="transparent" basis="full" direction="row-responsive">
        <AppCard
          appIsActive={true}
          appRoute={ROUTES.GET_NEXT}
          authorizedUser={authorizedUser} 
          background='status-ok' 
          basis='1/4'
          labelColor='light-1' 
          labelHeading='getNext' 
          labelBody='( active! )'
          modalBorderColor='status-ok'
          modalCloserColor='neutral-1' 
          promoHeading='getNext ( active! )'
          promoBody='our job post aggregator reduces the time between gigs. know what your next gig is before your current gig is complete.
                eliminate uncertainty by using getNext(Gig) to find, filter, and rank jobs across multiple job sites. 
                track your application to that gig and our algorithms use that information to find your next gig, with better matching for your preferences and likelihood to be hired.
                powered by  Google’s Artificial Intelligence service Cloud Talent Solution, getNext(Gig) helps eliminate uncertainty and reduce the time it takes to get hired at your next gig.
                job sites work for the employer and you are their product. let us work for you.'
        />
        <AppCard
          appIsActive={false}
          appRoute={null}
          authorizedUser={authorizedUser} 
          background='brand' 
          basis='1/4'
          labelColor='light-1' 
          labelHeading='pipeline' 
          labelBody='(coming soon)'
          modalBorderColor='brand'
          modalCloserColor='brand' 
          promoHeading='pipeline (coming soon)'
          promoBody='our Customer Relationship Management application provides all the critical functionality you need to find new customers, manage customer accounts, and retain customers - without having to become a CRM software expert. 
          spend LESS time using our software and more time focusing on your customers. planned features include: contact management, email marketing campaigns, automated emails and reminders, customer account management, retention management.'
        />
        <AppCard
          appIsActive={false}
          appRoute={null}
          authorizedUser={authorizedUser} 
          background='accent-3' 
          basis='1/4'
          labelColor='brand' 
          labelHeading='catchPay' 
          labelBody='(coming soon)'
          modalBorderColor='accent-3'
          modalCloserColor='brand' 
          promoHeading='catchPay (coming soon)'
          promoBody={null}
        />
        <AppCard
          appIsActive={false}
          appRoute={null}
          authorizedUser={authorizedUser} 
          background='accent-2' 
          basis='1/4'
          labelColor='light-1' 
          labelHeading='leadGen' 
          labelBody='(coming soon)'
          modalBorderColor='accent-2'
          modalCloserColor='accent-2' 
          promoHeading='leadGen (coming soon)'
          promoBody={null}
        />
      </Box>
      <Box background="transparent" basis="full" direction="row-responsive">
        <AppCard
          appIsActive={false}
          appRoute={null}
          authorizedUser={authorizedUser} 
          background='brand' 
          basis='1/3'
          labelColor='light-1' 
          labelHeading='contact' 
          labelBody='(coming soon)'
          modalBorderColor='brand'
          modalCloserColor='brand' 
          promoHeading='contact (coming soon)'
          promoBody={null}
        />
        <AppCard
          appIsActive={false}
          appRoute={null}
          authorizedUser={authorizedUser} 
          background='brand' 
          basis='1/3'
          labelColor='light-1' 
          labelHeading='inStock' 
          labelBody='(coming soon)'
          modalBorderColor='brand'
          modalCloserColor='brand' 
          promoHeading='inStock (coming soon)'
          promoBody={null}
        />
        <AppCard
          appIsActive={false}
          appRoute={null}
          authorizedUser={authorizedUser} 
          background='accent-3' 
          basis='1/3'
          labelColor='brand' 
          labelHeading='advert' 
          labelBody='(coming soon)'
          modalBorderColor='brand'
          modalCloserColor='brand' 
          promoHeading='advert (coming soon)'
          promoBody={null}
        />
      </Box>
      <Box background="transparent" basis="full" direction="row-responsive">
        <AppCard
          appIsActive={false}
          appRoute={null}
          authorizedUser={authorizedUser} 
          background='accent-3' 
          basis='1/2'
          labelColor='brand' 
          labelHeading='botkeeper' 
          labelBody='(coming soon)'
          modalBorderColor='brand'
          modalCloserColor='brand' 
          promoHeading='botkeeper (coming soon)'
          promoBody={null}
        />
        <AppCard
          appIsActive={false}
          appRoute={null}
          authorizedUser={authorizedUser} 
          background='accent-2' 
          basis='1/2'
          labelColor='light-1' 
          labelHeading='openNow' 
          labelBody='(coming soon)'
          modalBorderColor='brand'
          modalCloserColor='brand' 
          promoHeading='openNow (coming soon)'
          promoBody={null}
        />
      </Box>
      <Box background="transparent" basis="full" direction="row-responsive">
        <AppCard
          appIsActive={false}
          appRoute={null}
          authorizedUser={authorizedUser} 
          background='accent-2' 
          basis='3/4'
          labelColor='light-1' 
          labelHeading='shopCloud marketplace' 
          labelBody='(coming soon)'
          modalBorderColor='brand'
          modalCloserColor='brand' 
          promoHeading='shopCloud marketplace (coming soon)'
          promoBody={null}
        />
        <AppCard
          appIsActive={false}
          appRoute={null}
          authorizedUser={authorizedUser} 
          background='accent-3' 
          basis='3/4'
          labelColor='brand' 
          labelHeading='dataStudio' 
          labelBody='(coming soon)'
          modalBorderColor='brand'
          modalCloserColor='brand' 
          promoHeading='dataStudio (coming soon)'
          promoBody={null}
        />
      </Box>
      <Box
        background="transparent"
        border={{ color: 'dark-6', size: 'large' }}
        basis="full"
        direction="row-responsive"
        margin={{ top: 'medium' }}
      >
        <Box
          align="center"
          background="transparent"
          basis="full"
          height="small"
        >
          <Heading color="dark-6" level="2" margin={{ top: 'large' }}>
            integration with other apps we use at zaaas.io
          </Heading>
        </Box>
      </Box>
    </Box>
  );
};

export default compose(withRouter)(LandingPage);
